import { create } from 'zustand'

import type {
  AlertSeverity,
  AlertStatus,
  FlagStatus,
} from '@/types/controlCenter'

type ControlCenterStore = {
  flagsSearchQuery: string
  alertsSearchQuery: string
  flagStatusFilter: FlagStatus | 'all'
  alertStatusFilter: AlertStatus | 'all'
  alertSeverityFilter: AlertSeverity | 'all'
  setFlagsSearchQuery: (query: string) => void
  setAlertsSearchQuery: (query: string) => void
  setFlagStatusFilter: (filter: FlagStatus | 'all') => void
  setAlertStatusFilter: (filter: AlertStatus | 'all') => void
  setAlertSeverityFilter: (filter: AlertSeverity | 'all') => void
}

export const useControlCenterStore = create<ControlCenterStore>((set) => ({
  flagsSearchQuery: '',
  alertsSearchQuery: '',
  flagStatusFilter: 'all',
  alertStatusFilter: 'all',
  alertSeverityFilter: 'all',
  setFlagsSearchQuery: (query) => set({ flagsSearchQuery: query }),
  setAlertsSearchQuery: (query) => set({ alertsSearchQuery: query }),
  setFlagStatusFilter: (filter) => set({ flagStatusFilter: filter }),
  setAlertStatusFilter: (filter) => set({ alertStatusFilter: filter }),
  setAlertSeverityFilter: (filter) => set({ alertSeverityFilter: filter }),
}))
